import React from 'react';

const UserPage = () => (
  <div>UserPage</div>
);

export default UserPage;
